import { CRM_API, RequestHelper } from "utils";

const RUTA = "solicitudcompaniatenant";

export const SolicitudCompaniaTenantService = (() => {
  const buscarSolicitudCompaniaTenantPorId = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).get(`${RUTA}/BuscarSolicitudCompaniaTenantPorId`, data);
    });
  };

  const listarSolicitudes = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).get(`${RUTA}/ListarSolicitudes`, params);
    });
  };

  const crearCompaniaVinculada = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/CrearCompaniaVinculada`, params);
    });
  };

  const reactivarCompaniVinculada = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/ReactivarCompaniVinculada`, params);
    });
  };

  const actualizarSolicitudCompaniaTenant = function (args) {
    return new Promise((res) => res(args)).then((data) => {
      return RequestHelper(CRM_API).post(`${RUTA}/ActualizarSolicitudCompaniaTenant`, data);
    });
  };

  const bloquearCancelarCompania = function (args) {
    return new Promise((res) => res(args)).then((params) => {
      return RequestHelper(CRM_API).post(`${RUTA}/BloquearCancelarCompania`, params);
    });
  };

  return {
    buscarSolicitudCompaniaTenantPorId,
    listarSolicitudes,
    crearCompaniaVinculada,
    reactivarCompaniVinculada,
    actualizarSolicitudCompaniaTenant,
    bloquearCancelarCompania
  };
})();